import { SharedColors } from '@fluentui/theme';

export const colors = [
    SharedColors.red10,
    SharedColors.orange10,
    SharedColors.yellowGreen10,
    SharedColors.cyan30,
    SharedColors.cyanBlue10,
    SharedColors.blueMagenta10,
    SharedColors.magentaPink10,
    SharedColors.red20,
    SharedColors.orange20,
    SharedColors.orangeYellow10,
    SharedColors.greenCyan10,
    SharedColors.cyanBlue20,
    SharedColors.blueMagenta20,
    SharedColors.magentaPink20,
    SharedColors.redOrange10,
    SharedColors.yellow10,
    SharedColors.green20,
    SharedColors.cyan20,
    SharedColors.blue10,
    SharedColors.magenta20,
    SharedColors.pinkRed10,
    SharedColors.orange30,
    SharedColors.orangeYellow20,
    SharedColors.green10,
    SharedColors.cyan10,
    SharedColors.blueMagenta30,
    SharedColors.magenta10,
];
